import { Controller } from "@hotwired/stimulus"
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

export default class extends Controller {
    connect() {
        Fancybox.bind(this.element, "[data-fancybox]", {})
    }

    disconnect() {
        Fancybox.unbind(this.element)
        Fancybox.close()
    }
}
